<template>
  <div class="vertical-nav-header d-flex align-center justify-space-between ps-6 pe-5 pt-5 pb-2">
    <router-link
      to="/"
      class="d-flex align-center text-decoration-none"
    >
      <!-- <v-img
        :src="appLogo"
        max-height="30px"
        max-width="30px"
        alt="logo"
        contain
        eager
        class="app-logo me-3"
      ></v-img> -->
      <v-img
        :src="imagePath"
        max-height="25px"
        max-width="25px"
        alt="logo do sistema"
        contain
        eager
        class="app-logo me-3"
      ></v-img>
      <v-slide-x-transition>
        <h2
          v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
          class="app-title text--primary"
        >
          {{ appName }}
        </h2>
      </v-slide-x-transition>
    </router-link>

    <v-slide-x-transition>
      <div
        v-show="!(menuIsVerticalNavMini && !isMouseHovered)"
        v-if="$vuetify.breakpoint.lgAndUp"
        class="d-flex align-center ms-1"
        @click.stop="menuIsVerticalNavMini = !menuIsVerticalNavMini"
      >
        <v-icon
          v-show="!menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiRecordCircleOutline }}
        </v-icon>
        <v-icon
          v-show="menuIsVerticalNavMini"
          size="20"
          class="cursor-pointer"
        >
          {{ icons.mdiRadioboxBlank }}
        </v-icon>
      </div>
      <v-icon
        v-else
        size="20"
        class="d-inline-block"
        @click.stop="$emit('close-nav-menu')"
      >
        {{ icons.mdiClose }}
      </v-icon>
    </v-slide-x-transition>
  </div>
</template>

<script>
import useAppConfig from '@core/@app-config/useAppConfig'
import {
  mdiClose, mdiHome, mdiRadioboxBlank, mdiRecordCircleOutline,
} from '@mdi/js'
import themeConfig from '@themeConfig'
import { inject } from '@vue/composition-api'

export default {
  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()
    const isMouseHovered = inject('isMouseHovered')

    // const appNme = ref('')

    return {
      menuIsVerticalNavMini,
      isMouseHovered,

      appLogo: themeConfig.app.logo,

      icons: {
        mdiHome,
        mdiClose,
        mdiRadioboxBlank,
        mdiRecordCircleOutline,
      },
    }
  },

  data() {
    return {
      appName: '',
      imagePath: '',
    }
  },
  created() {
    this.changeAppName()
  },
  methods: {
    async changeAppName() {
      // const location = window.location.href
      if (window.location.href.includes('nexus')) {
        this.appName = 'NEXUS'
        this.imagePath = require('@/assets/nexus-icon.svg')
      }
      if (window.location.href.includes('adm')) {
        this.appName = 'SYS ADMIN'
        this.imagePath = require('@/assets/adm-icon.svg')
      }
      if (window.location.href.includes('integrator')) {
        this.appName = 'INTEGRADOR'
        this.imagePath = require('@/assets/integrator-icon.svg')
      }
      if (window.location.href.includes('integrate')) {
        this.appName = 'INTEGRAÇÃO'
        this.imagePath = require('@/assets/integrator-icon.svg')
      }
      if (window.location.href.includes('personalDepartment')) {
        this.appName = 'DEP. PESSOAL'
        this.imagePath = require('@/assets/dp-icon.svg')
      }
      if (window.location.href.includes('nexusapp')) {
        this.appName = 'NEXUSAPP'
        this.imagePath = require('@/assets/up-nexus-icon.svg')
      }
      if (window.location.href.includes('sgq')) {
        this.appName = 'SGQ'
        this.imagePath = require('@/assets/sgq-icon.svg')
      }
      if (window.location.href.includes('explorer')) {
        this.appName = 'SMART QUERRY'
        this.imagePath = require('@/assets/smart-query.svg')
      }
      if (window.location.href.includes('utilities')) {
        this.appName = 'UTILITÁRIOS'
        this.imagePath = require('@/assets/utilities-icon.svg')
      }
      if (window.location.href.includes('crm')) {
        this.appName = 'Motoca CRM'
        this.imagePath = require('@/assets/crm-icon.svg')
      }
      if (window.location.href.includes('transport')) {
        this.appName = 'TRANSPORTE'
        this.imagePath = require('@/assets/mdiCarHatchback.svg')
      }
      if (window.location.href.includes('solicitations')) {
        this.appName = 'SOLICITAÇÕES'
        this.imagePath = require('@/assets/mdiFileSendOutline.svg')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}
</style>
